import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { environment } from '@env/environment';
import { AbstractPaginationService } from '@shared/services/abstract-pagination-service';
import { Observable } from 'rxjs';
import { RecognizedUnitsFilterModel } from '@core/models/filter.model';
import { IOkResponse } from '@module/registration/registration.model';
import { IRecognizedCreditRemittanceData } from '@module/unit-management/unit-management.model';

export const RECOGNIZED_UNITS_LIST = '/registry-server/obligation/recognizedUnits/search';
export const CREDIT_SERVICE = '/obps-service';
export const CALCULATE_RU_UNIT_QUANTITY = '/obps-service/remittanceAction/validateRuSerialNumber';

@Injectable({
  providedIn: 'root'
})
export class RecognizedUnitService extends AbstractPaginationService {

  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  getList(pagination: IApp.IPagination, filterState: RecognizedUnitsFilterModel = {}): Observable<IApp.IObligationManagementPage> {
    let params = new HttpParams();
    params = this.addPagination(params, pagination);
    return this.http.post<IApp.IRecognizedUnitPage>(`${ environment.apiUrl }${ RECOGNIZED_UNITS_LIST }`, filterState, { params });
  }

  doRuAction( uri:string, payload: any): Observable<IOkResponse> {
    return this.http.post<IOkResponse>(`${ environment.apiUrl }${ CREDIT_SERVICE }${ uri }`, payload);
   // return this.http.post<IOkResponse>(`http://localhost:8088/api${ CREDIT_SERVICE }${ uri }`, payload);
  }

  calculateRUQuantity(payload: any): Observable<IRecognizedCreditRemittanceData> {
    return this.http.post<IRecognizedCreditRemittanceData>(`${ environment.apiUrl }${ CALCULATE_RU_UNIT_QUANTITY }`, payload);
  }

}
